import {
  FETCH_POINTS,
  FETCH_POINTS_SUCCESS,
  FETCH_POINTS_ERROR,
  TOGGLE_NOTIFICATION_POINT,
  TOGGLE_NOTIFICATION_POINT_SUCCESS,
  TOGGLE_NOTIFICATION_POINT_ERROR,
  TOGGLE_POINT_EDITING_STATE,
  SAVE_NOTIFICATION_POINT,
  SAVE_NOTIFICATION_POINT_SUCCESS,
  SAVE_NOTIFICATION_POINT_ERROR,
  CONFIRM_NOTIFICATION_POINT_CODE,
  CONFIRM_NOTIFICATION_POINT_CODE_SUCCESS,
  CONFIRM_NOTIFICATION_POINT_CODE_ERROR,
  RESET_NOTIFICATION_POINT_CODE_VALIDATION,
  SEND_NOTIFICATION_POINT_CODE,
  SEND_NOTIFICATION_POINT_CODE_SUCCESS,
  SEND_NOTIFICATION_POINT_CODE_ERROR,
  TOGGLE_CONFIRMATION_CODE_POPUP,
} from './constants';

import {
  initNotificationPoints,
  togglePointEditingState,
  updateNotificationPointValue,
  setCodeValidity,
  resetNotificationPointCodeValidation,
  toggleSavingStatus,
  toggleCheckingStatus,
  toggleCodeSendingStatus,
  toggleConfirmationCodePopup,
  changeTogglingStatusOfNotificationPoint,
  toggleNotificationPoint,
} from '../../../../common';

const initialState = {
  isPointsFetching: false,
  points: null,
  pointsFetchingError: null,
  accountConvergent: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_POINTS:
      return {
        ...state,
        isPointsFetching: true,
      };
    case FETCH_POINTS_SUCCESS:
      return initNotificationPoints({
        ...state,
        isPointsFetching: false,
        pointsFetchingError: null,
        points: action.data,
        accountConvergent: action.accountConvergent,
      });
    case FETCH_POINTS_ERROR:
      return {
        ...state,
        isPointsFetching: false,
        pointsFetchingError: action.error,
        points: null,
      };
    case TOGGLE_NOTIFICATION_POINT:
      return changeTogglingStatusOfNotificationPoint(state, action.data, true);
    case TOGGLE_NOTIFICATION_POINT_SUCCESS:
      return toggleNotificationPoint(state, action.data);
    case TOGGLE_NOTIFICATION_POINT_ERROR:
      return changeTogglingStatusOfNotificationPoint({
        ...state,
        error: action.error,
      }, action.data, false);
    case TOGGLE_POINT_EDITING_STATE:
      return togglePointEditingState(state, action.data);
    case SAVE_NOTIFICATION_POINT:
      return toggleSavingStatus(state, action.data, true);
    case SAVE_NOTIFICATION_POINT_SUCCESS:
      return initNotificationPoints(
        togglePointEditingState(
          updateNotificationPointValue(state, action.data),
          {
            type: action.data.type,
            isEditing: false,
          },
        ),
      );
    case SAVE_NOTIFICATION_POINT_ERROR:
      return toggleSavingStatus({
        ...state,
        error: action.error,
      }, action.data, false);
    case CONFIRM_NOTIFICATION_POINT_CODE:
      return toggleCheckingStatus(state, action.data, true);
    case CONFIRM_NOTIFICATION_POINT_CODE_SUCCESS:
      return initNotificationPoints(setCodeValidity(state, action.data, false));
    case CONFIRM_NOTIFICATION_POINT_CODE_ERROR:
      return toggleCheckingStatus(
        setCodeValidity(state, action.data, true),
        action.data,
        false,
      );
    case RESET_NOTIFICATION_POINT_CODE_VALIDATION:
      return resetNotificationPointCodeValidation(state, action.data);
    case SEND_NOTIFICATION_POINT_CODE:
      return toggleCodeSendingStatus(state, action.data, true);
    case SEND_NOTIFICATION_POINT_CODE_SUCCESS:
      return toggleCodeSendingStatus(state, action.data, false);
    case SEND_NOTIFICATION_POINT_CODE_ERROR:
      return toggleCodeSendingStatus({
        ...state,
        error: action.error,
      }, action.data, false);
    case TOGGLE_CONFIRMATION_CODE_POPUP:
      return toggleConfirmationCodePopup(state, action.data);
    default:
      return state;
  }
}
